import { createContext, useContext, useState, useEffect } from "react";
import { userRepository } from "../../../di/di";
import { useNavigate } from "react-router-dom";
import Toast from "../../../components/popups/toast";
export const ContactUsContext = createContext();

export const ContactUsContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({ name: "", email: "", message: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      if(!recaptchaToken){
        Toast.error("Please verify you are not a robot");
        return;
      }

      setIsLoading(true);
      const response = await userRepository.userSendPublicContactUs({ name: name, email: email, message: message });
      if (response.success) {
        setIsLoading(false);
        setName("");
        setEmail("");
        setMessage("");
        setErrors({ name: "", email: "", message: "" });
        Toast.success("Message sent successfully");
        setIsSuccess(true);
      } else {
        setIsLoading(false);
        Toast.error("Failed to send message");
      }
    } catch (error) {
      setIsLoading(false);
      Toast.error("Failed to send message");
      setIsSuccess(false);
    }
  };

  const onRecaptchaError = (...args) => {
    console.log(args);
    setRecaptchaToken(null);
    Toast.error("Please verify you are not a robot");
  };

  const contextValue = {
    name,
    email,
    message,
    errors,
    isLoading,
    handleSubmit,
    recaptchaToken,
    isSubmitEnabled,
    isSuccess,
    setName,
    setEmail,
    setMessage,
    setErrors,
    setIsLoading,
    setRecaptchaToken,
    onRecaptchaError,
    setIsSubmitEnabled,
  };

  useEffect(() => {
    if(recaptchaToken){
      setIsSubmitEnabled(true);
    }else{
      setIsSubmitEnabled(false);
    }
  }, [recaptchaToken]);

  return <ContactUsContext.Provider value={contextValue}>{children}</ContactUsContext.Provider>;
};

export const useContactUsContext = () => {
  return useContext(ContactUsContext);
};
